"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextButton = exports.PreviousButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./Pagination.style"));

var _SquareBorderButton = _interopRequireDefault(require("../Button/SquareBorderButton"));

var _DarkSquareBorderButton = _interopRequireDefault(require("../Button/DarkSquareBorderButton"));

var PreviousButton = function PreviousButton(_ref) {
  var current = _ref.current,
      firstPage = _ref.firstPage,
      onClick = _ref.onClick,
      isDarkTheme = _ref.isDarkTheme;

  if (isDarkTheme) {
    return _react.default.createElement(_DarkSquareBorderButton.default, {
      onClick: onClick,
      size: "medium",
      className: s.button,
      disabled: current === firstPage
    }, "Prev");
  }

  return _react.default.createElement(_SquareBorderButton.default, {
    onClick: onClick,
    className: s.button,
    text: "Prev",
    disabled: current === firstPage
  });
};

exports.PreviousButton = PreviousButton;

var NextButton = function NextButton(_ref2) {
  var current = _ref2.current,
      lastPage = _ref2.lastPage,
      onClick = _ref2.onClick,
      isDarkTheme = _ref2.isDarkTheme;

  if (isDarkTheme) {
    return _react.default.createElement(_DarkSquareBorderButton.default, {
      onClick: onClick,
      size: "medium",
      className: (0, _classnames.default)(s.button, s.nextButton),
      disabled: current === lastPage
    }, "Next");
  }

  return _react.default.createElement(_SquareBorderButton.default, {
    onClick: onClick,
    className: (0, _classnames.default)(s.button, s.nextButton),
    text: "Next",
    disabled: current === lastPage
  });
};

exports.NextButton = NextButton;